<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <header class="mbs-wizard_form-header mb-4">
    <div class="mbs-wizard_form-description">
      {{ 'wizards:schedule_subtitle' | i18next: { type: subtitleByType } }}
    </div>
  </header>

  <div
    class="mbs-wizard_form-content"
    [class.pb-3]="isNBF">
    <mbs-form-group>
      <mbs-radio
        formControlName="ScheduleType"
        name="ScheduleType"
        value="noschedule"
        [id]="elementSelectors.id.scheduleTypeRadio1"
        [label]="'wizards:no_schedule_label' | i18next"
        (change)="scheduleTypeChangeHandler($event)"></mbs-radio>

      <mbs-radio
        *ngIf="canShowFFI || isFFIEnabled"
        formControlName="ScheduleType"
        name="ScheduleType"
        value="ffi"
        [disabledSelf]="!!invalidFFIStorage || !isFFIEnabled || !!invalidFFIStorageBySynthetic"
        [id]="elementSelectors.id.scheduleTypeRadio6"
        [label]="isFFIEnabled ? (!!hasFFIProblem ? invalidLabelFFI : labelFFI) : labelFFI"
        (change)="scheduleTypeChangeHandler($event)"></mbs-radio>

      <mbs-radio
        *ngIf="!isNBF || isRestore"
        formControlName="ScheduleType"
        name="ScheduleType"
        value="once"
        [descriptionOutside]="false"
        [id]="elementSelectors.id.scheduleTypeRadio2"
        [label]="'wizards:specific_date_label' | i18next"
        (change)="scheduleTypeChangeHandler($event)">
        <ng-template
          radioDescription
          [hide]="stepForm.get('ScheduleType').value !== 'once'">
          <div
            class="form-row"
            formGroupName="specificDateGroup">
            <div class="col-3">
              <mbs-datepicker
                formControlName="date"
                [id]="'specific-date-group-date-picker'"
                [needSetCurrent]="true"></mbs-datepicker>
            </div>
            <div class="col-3">
              <mbs-timepicker
                formControlName="time"
                [id]="'specific-date-group-time-picker'"
                [meridian]="true"
                [needChangeInvalid]="true"></mbs-timepicker>
            </div>
          </div>
        </ng-template>
      </mbs-radio>

      <mbs-radio
        *ngIf="!isRestore && !isConsistencyCheck && (isNBF || !isUnix || isNetBuild)"
        formControlName="ScheduleType"
        name="ScheduleType"
        value="predefined"
        [descriptionOutside]="false"
        [id]="elementSelectors.id.scheduleTypeRadio3"
        [label]="!isNBF ? ('wizards:predefined_label' | i18next) : ('wizards:incremental_label' | i18next)"
        [labelClasses]="'d-flex align-items-center'"
        (change)="scheduleTypeChangeHandler($event)">
        <ng-container
          *ngIf="isNBF"
          appendLabel>
          <mbs-button
            class="ml-3"
            [disabled]="stepForm.get('ScheduleType').value !== 'predefined'"
            [id]="elementSelectors.id.scheduleTypeRadio3Edit"
            [isCtrl]="true"
            (click)="openScheduleModal('incremental', true)"
            >{{ 'shared:buttons.edit' | i18next }}</mbs-button
          >
        </ng-container>
        <ng-template
          radioDescription
          [hide]="isNBF">
          <div class="text-xs">
            {{ 'wizards:incremental_subtitle' | i18next }}
          </div>
        </ng-template>
      </mbs-radio>

      <mbs-radio
        *ngIf="!isNBF || isRestore"
        formControlName="ScheduleType"
        name="ScheduleType"
        value="recurring"
        [descriptionOutside]="false"
        [id]="elementSelectors.id.scheduleTypeRadio4"
        [label]="'wizards:advanced_label' | i18next: { advanced: isRestore || isConsistencyCheck ? '' : '(advanced schedule)' }"
        (change)="scheduleTypeChangeHandler($event)">
        <ng-template radioDescription>
          <div class="text-xs">
            {{ 'wizards:advanced_subtitle' | i18next }}
          </div>
        </ng-template>
      </mbs-radio>

      <mbs-radio
        *ngIf="isBackupPlan && (!isUnix || isNetBuild) && !isNBF && !isConsistencyCheck"
        formControlName="ScheduleType"
        name="ScheduleType"
        value="instantly"
        [descriptionOutside]="false"
        [id]="elementSelectors.id.scheduleTypeRadio5"
        [label]="'wizards:real_time_label' | i18next"
        (change)="scheduleTypeChangeHandler($event)">
        <ng-template radioDescription>
          <div class="text-xs">
            {{ 'wizards:real_time_subtitle' | i18next }}
          </div>
        </ng-template>
      </mbs-radio>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="isNBF && !isRestore && !isConsistencyCheck"
      formGroupName="fullBackupData">
      <mbs-checkbox
        formControlName="enabled"
        [id]="elementSelectors.id.fullBackupEnabledCheckbox"
        [label]="isUnix && !isNetBuild ? ('wizards:execute_full_unix_label' | i18next) : ('wizards:execute_full_label' | i18next)"
        (change)="enabledFullChangeHandler($event)">
        <ng-container appendLabel>
          <mbs-button
            class="ml-3"
            [disabled]="stepForm.get('ScheduleType').value !== 'predefined' || !stepForm.get('fullBackupData')?.value?.enabled"
            [id]="elementSelectors.id.fullBackupEnabledCheckboxEdit"
            [isCtrl]="true"
            (click)="openScheduleModal(null, true)"
            >{{ 'shared:buttons.edit' | i18next }}</mbs-button
          >
        </ng-container>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group *ngIf="(isRestore && isNBF) || ((!isUnix || isNetBuild) && !isNBF && !isConsistencyCheck && !isSQLPlan)">
      <mbs-checkbox
        formControlName="syncBeforeRun"
        [id]="'sync-before-run-checkbox'"
        [label]="
          isRestore ? ('wizards:restores_sync_local_with_storage_label' | i18next) : ('wizards:sync_local_with_storage_label' | i18next)
        "></mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group *ngIf="!isConsistencyCheck">
      <div class="form-row align-items-center">
        <div class="col-auto">
          <mbs-checkbox
            formControlName="StopAfterEnabled"
            [id]="'stop-after-enabled-checkbox'"
            [label]="'wizards:stop_plan_label' | i18next"
            (change)="stopAfterEnabledChangeHandler($event)"></mbs-checkbox>
        </div>
        <div class="col">
          <div class="form-row align-items-center">
            <div class="col-2">
              <mbs-number
                formControlName="stopAfterHours"
                [id]="'stop-after-hours-number'"
                [min]="0"
                (change)="stopAfterHoursChangeHandler($event)"></mbs-number>
            </div>
            <div class="col-auto">
              <label
                class="mbs-form_label mb-0"
                for="stop-after-hours-number"
                [class.-disabled]="!stepForm.get('StopAfterEnabled').value">
                {{ 'wizards:hours' | i18next }}
              </label>
            </div>

            <div class="col-2">
              <mbs-number
                formControlName="stopAfterMinutes"
                [id]="'stop-after-minutes-number'"
                [max]="59"
                [min]="0"></mbs-number>
            </div>
            <div class="col-auto">
              <label
                class="mbs-form_label mb-0"
                for="stop-after-minutes-number"
                [class.-disabled]="!stepForm.get('StopAfterEnabled').value">
                {{ 'wizards:minutes' | i18next }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </mbs-form-group>

    <mbs-form-group *ngIf="showOverdue">
      <div class="form-row align-items-center">
        <div class="col-auto">
          <mbs-checkbox
            formControlName="overdueAfterSuccessEnabled"
            [id]="'overdue-after-success-enabled-checkbox'"
            [label]="'wizards:overdue_label' | i18next"
            (change)="overdueAfterSuccessChangeHandler($event)"></mbs-checkbox>
        </div>
        <div class="col">
          <div class="form-row align-items-center">
            <div class="col-2">
              <mbs-number
                formControlName="overdueAfterSuccessAmount"
                [min]="1"></mbs-number>
            </div>
            <div class="col-3">
              <mbs-select
                formControlName="overdueAfterSuccessPeriod"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [hideSelected]="true"
                [id]="'overdue-after-success-period-select'"
                [items]="OverduePeriod"
                [searchable]="false"></mbs-select>
            </div>
            <div class="col-7">
              <label
                class="mbs-form_label mb-0"
                for="overdue-after-success-period-select"
                [class.-disabled]="!stepForm.get('overdueAfterSuccessEnabled').value">
                {{ 'wizards:overdue_without_success' | i18next }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </mbs-form-group>

    <mbs-form-group *ngIf="!isConsistencyCheck">
      <mbs-checkbox
        formControlName="ForceMissedSchedule"
        [id]="'run-missed-checkbox'"
        [label]="'wizards:run_missed_label' | i18next"></mbs-checkbox>
    </mbs-form-group>
  </div>

  <mbs-form-group
    *ngIf="minPeriodAlert as alert"
    [id]="elementSelectors.id.minPeriodAlert"
    [ngSwitch]="alert">
    <mbs-alert
      *ngSwitchCase="'simple'"
      class="mb-0"
      [icon]="true"
      [type]="mbsPopupType.info">
      <strong>{{ 'wizards:retention.simpleSchedule.minPeriodAlertTitle' | i18next: { name: storage.name } }}</strong>
      <div class="mt-1">
        <span
          [innerHTML]="
            'wizards:retention.simpleSchedule.minPeriodAlert' | i18next: { name: storage.name, minPeriod: storage.minPeriod } | safe: 'html'
          "
          (click)="minPeriodAlertClickHandler($event)"></span
        >.
        <ng-container *ngTemplateOutlet="minPeriodLearnMore"></ng-container>
      </div>
    </mbs-alert>

    <mbs-alert
      *ngSwitchCase="'advanced'"
      class="mb-0"
      [icon]="true"
      [type]="mbsPopupType.info">
      <span
        [innerHTML]="'wizards:retention.advancedSchedule.minPeriodAdvancedAlert' | i18next: { minPeriod: storage.minPeriod } | safe: 'html'"
        (click)="minPeriodAlertClickHandler($event)"></span
      >.
      <ng-container *ngTemplateOutlet="minPeriodLearnMore"></ng-container>
    </mbs-alert>
  </mbs-form-group>

  <mbs-form-group
    *ngIf="!isRestore && isNBF && (stepForm.get('ScheduleType').value === 'predefined' || stepForm.get('ScheduleType').value === 'ffi')">
    <mbs-card [size]="MbsSize.sm">
      <mbs-card-header [title]="'Total info:'"></mbs-card-header>
      <p
        *ngIf="stepForm.get('fullBackupData')?.value?.enabled && stepForm.get('ScheduleType').value !== 'ffi'"
        class="mb-0">
        {{ 'wizards:full_text' | i18next }} {{ schedulesTexts.fullBackupData }}
      </p>

      <p
        *ngIf="stepForm.get('ScheduleType').value === 'predefined'"
        class="mb-0">
        {{ 'wizards:incremental_text' | i18next }} {{ schedulesTexts.incrementalData }}
      </p>
      <p
        *ngIf="stepForm.get('ScheduleType').value === 'ffi'"
        class="mb-0">
        {{ 'wizards:ffi_label' | i18next }}: {{ schedulesTexts.incrementalData }}
      </p>
    </mbs-card>
  </mbs-form-group>
</section>

<ng-template #minPeriodLearnMore>
  <a
    class="ml-2 no-wrap"
    target="_blank"
    [helpLink]="'/AP/Help/backup/about/retention-policy'"
    [kbMode]="true">
    {{ 'shared:buttons.learnMore' | i18next }}
  </a>
</ng-template>

<ng-template #fastNTFSModalContent>
  <p>{{ 'wizards:fast_ntfs_not_support_text' | i18next }}</p>
  <mbs-alert
    class="mb-0"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:fast_ntfs_not_support_alert_text' | i18next }}
  </mbs-alert>
</ng-template>

<ng-template #labelFFI>
  <span>{{ 'wizards:ffi_label' | i18next }}</span>
  <span>
    <mbs-button
      class="ml-3"
      [disabled]="!isFFIEnabled || stepForm.get('ScheduleType').value !== 'ffi'"
      [id]="elementSelectors.id.scheduleTypeRadio6Edit"
      [isCtrl]="true"
      (click)="openScheduleModal('ffi', true)"
      >{{ 'shared:buttons.edit' | i18next }}</mbs-button
    >
  </span>
  <p
    *ngIf="isFFIEnabled"
    class="text-sm mb-0 mt-1">
    {{ 'wizards:ffi_label_info' | i18next }}
  </p>
  <p
    *ngIf="isFFIEnabled"
    class="mb-0">
    <strong class="text-sm">{{ 'wizards:ffi_label_note' | i18next }}</strong>
  </p>
  <mbs-alert
    *ngIf="isRDMode || canShowFFI"
    class="{{ isFFIEnabled ? 'mt-1' : 'mt-3' }}"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:ffi_label_min_version_attention' | i18next }}
  </mbs-alert>
</ng-template>

<ng-template #invalidLabelFFI>
  <span>{{ 'wizards:ffi_label' | i18next }}</span>
  <mbs-alert
    class="mt-3"
    [icon]="true"
    [type]="mbsPopupType.danger">
    {{ simpleDisabledMessage }}
  </mbs-alert>
</ng-template>
